import Helpers from '@helpers';

const initKeypressValidators = () => {
    $('.no-english-character').keypress(e => {
        if (e.which > 64 && e.which < 128) {
            return false;
        }
    });

    $('.no-space').keypress(e => {
        if (e.which === 32) {
            return false;
        }
    });

    $('.no-number').keypress(e => {
        if (e.which > 48 && e.which < 57) {
            return false;
        }
    });

    $('.just-number').keydown(e => {
        if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
            return false;
        }
    });

    $('.currency').keypress(function(e) {
        // If not number
        if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
            return false;
        }

        // Max 10 digits
        const trimmed = $(this).val().toString().replace(/[^\d.]/g, '');
        if (trimmed.length > 11) return false;
    });

    $('.currency').keyup(function() {
        $(this).val(Helpers.Utils.getThousandSeperated($(this).val()));
    });
};

export {
    initKeypressValidators
};
